import { MainMenu } from '../MainMenu';

export function SectionLayout(props: { children: Array<JSX.Element> | JSX.Element, isEmbed?: boolean }) {
    if (props.isEmbed) {
        return <div>
            {props.children}
        </div>
    } else {
        return <div className='grid min-h-[85vh]'>
            <div className="mx-auto w-full" style={{ gridColumn: 1, gridRow: 1 }}>
                <div className='sticky top-0 z-50 bg-bg bg-bg-gray'>
                    <MainMenu hasSearch={true}></MainMenu>
                </div>
                <div className="container max-w-[90rem] mx-auto w-full kb-content-container">
                    {props.children}
                </div>
            </div>
        </div>
    }
}